module.exports = __webpack_public_path__ + "static/jc04657-preparation-step-01-6c9898374a218518aa887cfa248b3f0c.png";